import React from "react";
import {
    GridActionsCellItem,
    GridActionsCellItemProps,
    GridRenderCellParams,
    GridRowId,
    GridRowModes,
    useGridApiContext,
} from "@mui/x-data-grid-premium";
import IconButton, { IconButtonProps } from "@mui/material/IconButton";
import { GridApiPremium } from "@mui/x-data-grid-premium/models/gridApiPremium";

interface IMuiEditableDataGridActionCellItemProps {
    isEdit?: boolean;
    fieldToFocus?: string;
    params: GridRenderCellParams;
}

type MuiEditableDataGridActionCellItemProps =
    IMuiEditableDataGridActionCellItemProps & GridActionsCellItemProps;

export const MuiEditableDataGridActionCellItem = ({
    isEdit,
    fieldToFocus,
    onClick,
    params,
    ...props
}: MuiEditableDataGridActionCellItemProps) => {
    const apiRef = useGridApiContext();

    const handleClick = (
        e: React.MouseEvent<HTMLButtonElement, MouseEvent> &
            React.MouseEvent<HTMLLIElement, MouseEvent>
    ) => {
        if (isEdit) {
            startEditMode(params.id, apiRef.current, fieldToFocus);
        }

        if (!!onClick) {
            onClick(e);
        }
    };

    return (
        <GridActionsCellItem
            disabled={isInEditMode(params.id, apiRef?.current)}
            onClick={handleClick}
            {...props}
        />
    );
};

type MuiEditableDataGridActionIconButtonProps =
    IMuiEditableDataGridActionCellItemProps & IconButtonProps;

export const MuiEditableDataGridActionIconButton = ({
    isEdit,
    fieldToFocus,
    onClick,
    params,
    ...props
}: MuiEditableDataGridActionIconButtonProps) => {
    const apiRef = useGridApiContext();

    const handleClick = (
        e: React.MouseEvent<HTMLButtonElement, MouseEvent> &
            React.MouseEvent<HTMLLIElement, MouseEvent>
    ) => {
        if (isEdit) {
            startEditMode(params.id, apiRef.current, fieldToFocus);
        }

        if (!!onClick) {
            onClick(e);
        }
    };

    return (
        <IconButton
            disabled={isInEditMode(params.id, apiRef?.current)}
            size="small"
            onClick={handleClick}
            {...props}
        />
    );
};

const startEditMode = (
    id: GridRowId,
    apiRef: GridApiPremium,
    fieldToFocus?: string
) => {
    if (apiRef?.getRowMode(id) === GridRowModes.View) {
        apiRef?.startRowEditMode({ id, fieldToFocus });
    }
};

const isInEditMode = (id: GridRowId, apiRef: GridApiPremium) =>
    apiRef?.getRowMode(id) === GridRowModes.Edit;
